import React from 'react';

const PaginationBar = ({
  page,
  totalPages,
  total,
  startIndex,
  endIndex,
  hasPrev,
  hasNext,
  onPageChange,
  itemLabel = "listings",
  compact = false
}) => {
  if (total === 0) return null;
  const singularLabels = { properties: "property", listings: "listing", rentals: "rental", favorites: "favorite", articles: "article", investments: "investment" };
  const label = total === 1 ? (singularLabels[itemLabel] || itemLabel) : itemLabel;
  if (totalPages <= 1) {
    return (
      <div className={`pagination-bar pagination-bar--single${compact ? " pagination-bar--compact" : ""}`}>
        <span className="pagination-summary">{total} {label}</span>
      </div>
    );
  }
  return (
    <nav className={`pagination-bar${compact ? " pagination-bar--compact" : ""}`} aria-label="Listings pagination">
      <span className="pagination-summary">
        Showing {startIndex}–{endIndex} of {total} {label}
      </span>
      <div className="pagination-controls">
        <button type="button" className="pagination-btn" disabled={!hasPrev} onClick={() => onPageChange(page - 1)} aria-label="Previous page">
          <i className="fas fa-chevron-left" aria-hidden="true"></i> Previous
        </button>
        <span className="pagination-page-indicator" aria-live="polite">Page {page} of {totalPages}</span>
        <button type="button" className="pagination-btn" disabled={!hasNext} onClick={() => onPageChange(page + 1)} aria-label="Next page">
          Next <i className="fas fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </nav>
  );
};

export default PaginationBar;
